import { TrendDataApi } from 'api/TrendDataApi';
import { backendApiClient } from 'container/backendApiClient';

export const trendDataApi = new TrendDataApi(backendApiClient);
